import React from 'react';
import { connect } from 'react-redux';

import { Form } from 'components/common';
import MainFieldSet from './MainFieldSet';

const PropertyForm = (props) => {
  const { showEditForm } = props.property;

  const onClose = () => {
    props.actions.property.showEditForm({ show: false });
  };

  const onSubmit = (data) => {
    const newData = Object.assign(data, {
      site: props.site.activeId,
    });
    props.actions.property.update(newData);
  };

  return (
    <Form
      title="Редактирование свойства"
      model={props.property}
      visible={showEditForm}
      onClose={onClose}
      onSubmit={onSubmit}
      initialValues={{ sort: 100 }}
    >
      <MainFieldSet {...props} />
    </Form>
  );
};

const mapState = (state) => ({
  site: state.site,
  property: state.property,
});

const mapDispatch = (dispatch) => ({
  actions: {
    property: dispatch.property,
  },
});

export default connect(mapState, mapDispatch)(PropertyForm);
